import { render, staticRenderFns } from "./DownloadLUT.vue?vue&type=template&id=a2f6f1f4&"
import script from "./DownloadLUT.vue?vue&type=script&lang=js&"
export * from "./DownloadLUT.vue?vue&type=script&lang=js&"
import style0 from "./DownloadLUT.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports